import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Inicio from '../pages';


function Navigation() { 
  return (
    <Router>
      <Routes>
        <Route path="/:param" element={<Inicio />} />
      </Routes>
    </Router>
  );
}

export default Navigation;
